import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, ExpandedTooltip, getUtility, Icon, SimpleModal } from '@livable/saas-react-components';
import { Box, Button, Chip, IconButton, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { ALLOCATION_METHOD, billStatuses } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { FileDetails } from './fileDetails';
import { ApplyBillingFullContent } from './content';
import { canDeleteRecoveredBill, getRecoveredBillDeleteHint, isAllocatedFromBill } from './BillAutomationExtraction';
import { useUploadedBillDelete } from './useUploadedBillDelete';
const ApplyBillingFull = observer(_ref => {
  var _store$homeDashboardS, _property$allocations, _property$allocations2, _statuses$applyBill$s, _statuses$applyBill$s2, _allocations$tempFile, _ref8, _ref9, _property$allocations4, _buildingInformation;
  let propertyProp = _ref.property;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Apply Billing';
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFileVisibilitySettingVisible = _useState2[0],
    setIsFileVisibilitySettingVisible = _useState2[1];
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const applyBill = currentCompany.billingTab.applyBill || {};
  const applyBillAutosave = currentCompany.billingTab.applyBillAutosave;
  const isAllPropertiesMode = store.homeDashboardStore.selectedPropertyId === 'all';
  const isOpen = currentCompany.billingTab.isApplyBillingIsOpen;
  const setApplyBill = currentCompany.billingTab.setApplyBill;
  const setIsOpen = currentCompany.billingTab.setIsApplyBillingIsOpen;
  const statuses = billStatuses(t);
  const property = isAllPropertiesMode ? ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompanyProperties) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.find(p => p.id === applyBill.propertyId)) || {} : propertyProp || {};
  const recoveredBillDelete = useUploadedBillDelete({
    property: propertyProp || property
  });
  const allocationCycleId = applyBill.allocationCycleId;
  const billingCycleIds = (_property$allocations = property === null || property === void 0 || (_property$allocations2 = property.allocations) === null || _property$allocations2 === void 0 || (_property$allocations2 = _property$allocations2.billingCycleIds) === null || _property$allocations2 === void 0 ? void 0 : _property$allocations2.get(allocationCycleId)) !== null && _property$allocations !== void 0 ? _property$allocations : [];
  // Same ordering as billing.jsx `utilityTables` (refresh): default billing cycle rows first, then additional.
  const utilitiesListFlat = billingCycleIds.flatMap(id => {
    var _property$allocations3, _cycle$utilityTables;
    const cycle = property === null || property === void 0 || (_property$allocations3 = property.allocations) === null || _property$allocations3 === void 0 || (_property$allocations3 = _property$allocations3.billingCycles) === null || _property$allocations3 === void 0 ? void 0 : _property$allocations3.get(id);
    const tables = (_cycle$utilityTables = cycle === null || cycle === void 0 ? void 0 : cycle.utilityTables) !== null && _cycle$utilityTables !== void 0 ? _cycle$utilityTables : [];
    return tables.map(row => {
      var _row$billingCycleId, _cycle$isDefaultBilli, _cycle$isHistoricalAl;
      return _objectSpread(_objectSpread({}, row), {}, {
        billingCycleId: (_row$billingCycleId = row.billingCycleId) !== null && _row$billingCycleId !== void 0 ? _row$billingCycleId : id,
        isDefaultBillingCycle: (_cycle$isDefaultBilli = cycle === null || cycle === void 0 ? void 0 : cycle.isDefaultBillingCycle) !== null && _cycle$isDefaultBilli !== void 0 ? _cycle$isDefaultBilli : false,
        isHistoricalAllocationCycle: (_cycle$isHistoricalAl = cycle === null || cycle === void 0 ? void 0 : cycle.isHistoricalAllocationCycle) !== null && _cycle$isHistoricalAl !== void 0 ? _cycle$isHistoricalAl : false
      });
    });
  }).sort((a, b) => Number(b.isDefaultBillingCycle) - Number(a.isDefaultBillingCycle));
  const utilitiesListNonSubmeter = utilitiesListFlat.filter(u => u.allocationMethod !== ALLOCATION_METHOD.BySubmeter);
  const currentUtilityIndex = utilitiesListNonSubmeter.findIndex(u => u.billingCycleId === applyBill.billingCycleId && u.utilityId === applyBill.utilityId);
  const hasPrev = currentUtilityIndex > 0;
  const hasNext = currentUtilityIndex >= 0 && currentUtilityIndex < utilitiesListNonSubmeter.length - 1;
  const getUtilityTitle = u => {
    var _ref2, _getUtility$title, _getUtility, _store$utilityProvide;
    return (_ref2 = (_getUtility$title = (_getUtility = getUtility((_store$utilityProvide = store.utilityProviders.utilities.get(u === null || u === void 0 ? void 0 : u.utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.utilityTypeName)) === null || _getUtility === void 0 ? void 0 : _getUtility.title) !== null && _getUtility$title !== void 0 ? _getUtility$title : u === null || u === void 0 ? void 0 : u.utilityId) !== null && _ref2 !== void 0 ? _ref2 : '';
  };
  const prevUtilityName = hasPrev ? getUtilityTitle(utilitiesListNonSubmeter[currentUtilityIndex - 1]) : '';
  const nextUtilityName = hasNext ? getUtilityTitle(utilitiesListNonSubmeter[currentUtilityIndex + 1]) : '';
  const buildApplyBillForUtilityRow = targetRow => {
    var _store$utilityProvide2, _store$properties$pro, _targetRow$allocation, _targetRow$billingCyc, _ref3, _targetRow$commonArea, _ref4, _targetRow$defaultGoo, _targetRow$billStatus, _utilityData$title;
    const utilityData = getUtility((_store$utilityProvide2 = store.utilityProviders.utilities.get(targetRow.utilityId)) === null || _store$utilityProvide2 === void 0 ? void 0 : _store$utilityProvide2.utilityTypeName);
    const utilityDataFromProviders = ((_store$properties$pro = store.properties.propertyUtilities) === null || _store$properties$pro === void 0 ? void 0 : _store$properties$pro.find(u => u.utilityId === targetRow.utilityId)) || {};
    const isPending = targetRow.billStatus === 'PendingCompletion';
    return _objectSpread(_objectSpread({}, applyBill), {}, {
      allocationMethod: (_targetRow$allocation = targetRow.allocationMethod) !== null && _targetRow$allocation !== void 0 ? _targetRow$allocation : applyBill.allocationMethod,
      billingCycleId: (_targetRow$billingCyc = targetRow.billingCycleId) !== null && _targetRow$billingCyc !== void 0 ? _targetRow$billingCyc : applyBill.billingCycleId,
      commonAreaDeduction: (_ref3 = (_targetRow$commonArea = targetRow.commonAreaDeduction) !== null && _targetRow$commonArea !== void 0 ? _targetRow$commonArea : utilityDataFromProviders.commonAreaDeduction) !== null && _ref3 !== void 0 ? _ref3 : applyBill.commonAreaDeduction,
      goodWillDeduction: isPending ? (_ref4 = (_targetRow$defaultGoo = targetRow.defaultGoodwillDeduction) !== null && _targetRow$defaultGoo !== void 0 ? _targetRow$defaultGoo : utilityDataFromProviders.goodWillDeduction) !== null && _ref4 !== void 0 ? _ref4 : applyBill.goodWillDeduction : null,
      isEditable: targetRow.isEditable,
      status: (_targetRow$billStatus = targetRow.billStatus) !== null && _targetRow$billStatus !== void 0 ? _targetRow$billStatus : applyBill.status,
      utilityId: targetRow.utilityId,
      utilityName: (_utilityData$title = utilityData === null || utilityData === void 0 ? void 0 : utilityData.title) !== null && _utilityData$title !== void 0 ? _utilityData$title : targetRow.utilityId
    });
  };
  const handlePrevUtility = () => {
    var _ref5, _ref5$resetTempFileDa, _currentCompany$billi, _currentCompany$billi2;
    if (!hasPrev) return;
    track(events.clicked('Previous Utility'), {
      page,
      utility: prevUtilityName
    });
    (_ref5 = propertyProp || property) === null || _ref5 === void 0 || (_ref5 = _ref5.allocations) === null || _ref5 === void 0 || (_ref5$resetTempFileDa = _ref5.resetTempFileData) === null || _ref5$resetTempFileDa === void 0 || _ref5$resetTempFileDa.call(_ref5);
    (_currentCompany$billi = (_currentCompany$billi2 = currentCompany.billingTab).setIsBillEdit) === null || _currentCompany$billi === void 0 || _currentCompany$billi.call(_currentCompany$billi2, false);
    const prev = utilitiesListNonSubmeter[currentUtilityIndex - 1];
    setApplyBill(buildApplyBillForUtilityRow(prev));
  };
  const handleNextUtility = () => {
    var _ref6, _ref6$resetTempFileDa, _currentCompany$billi3, _currentCompany$billi4;
    if (!hasNext) return;
    track(events.clicked('Next Utility'), {
      page,
      utility: nextUtilityName
    });
    (_ref6 = propertyProp || property) === null || _ref6 === void 0 || (_ref6 = _ref6.allocations) === null || _ref6 === void 0 || (_ref6$resetTempFileDa = _ref6.resetTempFileData) === null || _ref6$resetTempFileDa === void 0 || _ref6$resetTempFileDa.call(_ref6);
    (_currentCompany$billi3 = (_currentCompany$billi4 = currentCompany.billingTab).setIsBillEdit) === null || _currentCompany$billi3 === void 0 || _currentCompany$billi3.call(_currentCompany$billi4, false);
    const next = utilitiesListNonSubmeter[currentUtilityIndex + 1];
    setApplyBill(buildApplyBillForUtilityRow(next));
  };
  const handleClose = () => {
    var _ref7;
    track(events.modalClosed('Apply Billing'), {
      page,
      status: applyBill.status,
      utility: applyBill.utilityName
    });
    (_ref7 = propertyProp || property) === null || _ref7 === void 0 || (_ref7 = _ref7.allocations) === null || _ref7 === void 0 || _ref7.resetTempFileData();
    setIsOpen(false);
    currentCompany.billingTab.setIsBillEdit(false);
    setApplyBill({
      allocationCycleId: '',
      allocationMethod: '',
      billingCycleId: '',
      buildingAddress: '',
      commonAreaDeduction: null,
      cycleName: '',
      goodWillDeduction: null,
      propertyId: null,
      status: '',
      utilityId: '',
      utilityName: ''
    });
  };
  const defaultTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, applyBill.utilityName, " ", applyBill.cycleName), /*#__PURE__*/React.createElement(Chip, {
    label: (_statuses$applyBill$s = statuses[applyBill.status]) === null || _statuses$applyBill$s === void 0 ? void 0 : _statuses$applyBill$s.label,
    variant: (_statuses$applyBill$s2 = statuses[applyBill.status]) === null || _statuses$applyBill$s2 === void 0 ? void 0 : _statuses$applyBill$s2.variant
  }));

  /**
   * A bill recovered for this cycle can be deleted from here, but only when this screen is what
   * uploaded it, for this utility. Anything else answers for more than this allocation can see, and
   * belongs to the Bills page.
   */
  const recoveredBill = (_allocations$tempFile = (_ref8 = propertyProp || property) === null || _ref8 === void 0 || (_ref8 = _ref8.allocations) === null || _ref8 === void 0 || (_ref8 = _ref8.tempFileData) === null || _ref8 === void 0 ? void 0 : _ref8.billAutomationResponse) !== null && _allocations$tempFile !== void 0 ? _allocations$tempFile : null;
  const isRecovered = !!((_ref9 = propertyProp || property) !== null && _ref9 !== void 0 && (_ref9 = _ref9.allocations) !== null && _ref9 !== void 0 && (_ref9 = _ref9.tempFileData) !== null && _ref9 !== void 0 && _ref9.wasRecovered) && !!(recoveredBill !== null && recoveredBill !== void 0 && recoveredBill.billId);
  // The allocation on screen, whose bill may have been made from the recovered one (LB-5755). Looked up
  // the way the file pane looks up the utility it shows.
  const allocationUtility = property === null || property === void 0 || (_property$allocations4 = property.allocations) === null || _property$allocations4 === void 0 || (_property$allocations4 = _property$allocations4.utilityById) === null || _property$allocations4 === void 0 ? void 0 : _property$allocations4.get(applyBill.billingCycleId + applyBill.utilityId);
  const allocationBill = allocationUtility === null || allocationUtility === void 0 ? void 0 : allocationUtility.bill;
  const allocatedSourceBillId = allocationBill === null || allocationBill === void 0 ? void 0 : allocationBill.sourceBillId;
  // Billed: the table's statement has gone to residents, and the bill they were billed from stays (LB-5755). Closed:
  // its billing month is complete, and nothing allocated in it is altered (LB-5952).
  const deleteOptions = {
    allocatedSourceBillId,
    isBilled: applyBill.status === 'TableReadyStatementSent',
    isClosed: (allocationUtility === null || allocationUtility === void 0 ? void 0 : allocationUtility.isEditable) === false
  };
  const mayDeleteRecoveredBill = isRecovered && canDeleteRecoveredBill(recoveredBill, applyBill.utilityId, deleteOptions);
  const isRecoveredBillAllocatedHere = isAllocatedFromBill(recoveredBill, deleteOptions);
  const handleDeleteRecoveredBill = () => {
    if (!mayDeleteRecoveredBill) return;
    track(events.clicked('Delete Recovered Bill'), {
      page,
      utility: applyBill.utilityName
    });
    recoveredBillDelete.request(recoveredBill.billId, {
      isAllocatedHere: isRecoveredBillAllocatedHere
    });
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    hasAutosave: true,
    isMemoChildren: true,
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    title: defaultTitle,
    triggerAutosave: applyBillAutosave,
    subTitle: "".concat(isAllPropertiesMode ? applyBill.buildingAddress : (_buildingInformation = (propertyProp || property).buildingInformation) === null || _buildingInformation === void 0 ? void 0 : _buildingInformation.buildingAddress, " - Allocated by: ").concat(CONSTANTS.ALLOCATION_METHODS[applyBill.allocationMethod] || applyBill.allocationMethod),
    variant: 'flex'
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.modalPaper
  }, isRecovered ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: getRecoveredBillDeleteHint(mayDeleteRecoveredBill, {
      isAllocatedHere: isRecoveredBillAllocatedHere,
      isBilled: deleteOptions.isBilled,
      isClosed: deleteOptions.isClosed
    }),
    placement: "bottom"
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.recoveredDeleteFloating
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Delete this bill",
    disabled: !mayDeleteRecoveredBill,
    onClick: handleDeleteRecoveredBill,
    size: "large",
    'custom-attribute': 'recovered-bill-delete'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  })))) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalWrapper,
    key: "apply-billing-".concat(applyBill.billingCycleId, "-").concat(applyBill.propertyId, "-").concat(applyBill.utilityId)
  }, /*#__PURE__*/React.createElement(FileDetails, {
    onFileVisibilitySettingVisibleChange: setIsFileVisibilitySettingVisible
  }), /*#__PURE__*/React.createElement(ApplyBillingFullContent, {
    handleClose: handleClose,
    property: propertyProp || property
  })), utilitiesListNonSubmeter.length > 1 && /*#__PURE__*/React.createElement(Box, {
    className: [classes.utilitySwitcher, isFileVisibilitySettingVisible && classes.utilitySwitcherWithFileVisibility].filter(Boolean).join(' ')
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: handlePrevUtility,
    disabled: !hasPrev
  }, prevUtilityName ? "Prev: ".concat(prevUtilityName) : 'Prev'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, currentUtilityIndex >= 0 ? "".concat(currentUtilityIndex + 1, " / ").concat(utilitiesListNonSubmeter.length) : '—'), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: handleNextUtility,
    disabled: !hasNext
  }, nextUtilityName ? "Next: ".concat(nextUtilityName) : 'Next'))), recoveredBillDelete.confirmation);
});
export default ApplyBillingFull;